function decodeBonus(data = {}) {
  return {
    bgColor: data.bg_color,
    description: data.description,
    rulesDescription: data.rules_description,
    key: data.key,
    id: data.key,
    name: data.name,
    textColor: data.text_color,
    requiredSelections: data.required_selections || 1
  };
}

export default decodeBonus;
